module.exports = __webpack_public_path__ + "static/media/coding-programming-language-svgrepo-com (1).65e7f22f.svg";